import React from 'react'
// import { FaLinkedin, FaTwitter, FaFacebook, FaGithub } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const Footer = () => {
  // const handleSocialClick = (url) => {
  //   window.open(url, '_blank');
  // };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   alert('Response submitted!');
  // };

  return (
    <div id="contact" className="bg-gray-900 text-white py-12 px-6">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-y-12 md:gap-x-16 text-center md:text-left">
        <div>
          <h2 className="text-2xl font-semibold mb-6">Services</h2>
          <ul className="space-y-2 text-sm">
            <li>
                <Link
                    to="/services/data-analytics"
                    className="text-gray-100 hover:text-blue-600 transition-colors"
                >
                    Data Strategy Consulting
                </Link>
            </li>
            <li>
                <Link
                to="/services/business-intelligence"
                className="text-gray-100 hover:text-blue-600 transition-colors"
                >
                    Business Intelligence
                </Link>
            </li>
            <li>
                <Link
                to="/services/ai-and-ml"
                className="text-gray-100 hover:text-blue-600 transition-colors"
                >
                    AI & Machine Learning
                </Link>
            </li>
            <li>
                <Link
                to="/services/kpi-dashboarding"
                className="text-gray-100 hover:text-blue-600 transition-colors"
                >
                    KPI Dashboarding
                </Link>
            </li>
            <li>
                <Link
                to="/services/project-management"
                className="text-gray-100 hover:text-blue-600 transition-colors"
                >
                    Project Management
                </Link>
            </li>
            <li>
                <Link
                to="/services/website-development"
                className="text-gray-100 hover:text-blue-600 transition-colors"
                >
                    Website Development
                </Link>
            </li>
          </ul>
        </div>

        {/* Company */}
        <div>
          <h2 className="text-2xl font-semibold mb-6">Company</h2>
          <ul className="space-y-2 text-sm">
            <li>
              <Link
                to="/about"
                className="text-gray-100 hover:text-blue-600 transition-colors"
                >
                    About us
                </Link>
            </li>
            <li>Blog</li>
            <li>
                <Link
                to="/contact"
                className="text-gray-100 hover:text-blue-600 transition-colors"
                >
                    Contact
                </Link>
            </li>
            {/* <li>Careers</li> */}
          </ul>
        </div>

        {/* Contact Info & Socials */}
        <div>
          <h2 className="text-2xl font-semibold mb-6">Contact Info</h2>
          <p className="text-sm mb-2">
            New Delhi, India<br />
            Sub branch,<br />
            Kilcock, Co. Meath
          </p>
          <p className="text-sm mb-4">Email: info@jyotinayanalytics.com</p>
          {/* <div className="flex justify-center md:justify-start gap-4 mt-4">
            <FaLinkedin
              className="text-2xl hover:text-blue-400 cursor-pointer"
              onClick={() => handleSocialClick('https://linkedin.com')}
            />
            <FaTwitter
              className="text-2xl hover:text-blue-400 cursor-pointer"
              onClick={() => handleSocialClick('https://twitter.com')}
            />
            <FaFacebook
              className="text-2xl hover:text-blue-400 cursor-pointer"
              onClick={() => handleSocialClick('https://facebook.com')}
            />
            <FaGithub
              className="text-2xl hover:text-blue-400 cursor-pointer"
              onClick={() => handleSocialClick('https://github.com')}
            />
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Footer;
